
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { PermissionGroupSection, PermissionScopeLegend, visibleGroups } from "../PermissionTables.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SystemRoleModule_all, SystemRole__ToI18nString, PermissionGroup__ToI18nString, PermissionGroup__get_Key } from "../../../Shared/Roles.js";
import { map as map_1, ofArray, head } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Button, TextButton } from "../../../Components/Button.js";
import Arrow_Left_1 from "../../../../public/assets/icons/Arrow_Left_1.svg";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { FormState__getValidation, RoleId__get_unwrap } from "../../../Shared/Shared.js";
import { PageHeader } from "../../../Components/Text.js";
import { AreaAnchorMenu } from "../../../Widgets/AnchorMenu.js";
import { empty, singleton, append, map, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { InformationAlert, ErrorAlert } from "../../../Components/Alert.js";
import { Input } from "../../../Components/Input.js";
import { Msg } from "./Types.js";
import { unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";

function RoleForm(props) {
    let elems_7, elems_6, elems_1, elems, Label, matchValue_1, elems_2, elems_5;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const groups = visibleGroups(props.AccountSettings);
    const anchorId = (group) => concat("permission-group-", ...PermissionGroup__get_Key(group));
    let patternInput_1;
    const initial = anchorId(head(groups));
    patternInput_1 = reactApi.useState(initial);
    return reactElement("div", createObj(ofArray([["className", "flex grow flex-col"], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,minmax(0,80rem)]"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = t("general.back"), {
        ComponentState: componentState,
        Icon: Arrow_Left_1(),
        Label: Label,
        OnClick: () => {
            const matchValue = props.Kind;
            switch (matchValue.tag) {
                case 0:
                case 1: {
                    RouterModule_nav(ofArray(["settings", "roles"]), 1, 1);
                    break;
                }
                default:
                    RouterModule_nav(ofArray(["settings", "roles", RoleId__get_unwrap(matchValue.fields[0])]), 1, 1);
            }
        },
        TestId: "role-form-back-button",
        Variant: "default",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
        Text: (matchValue_1 = props.Kind, (matchValue_1.tag === 0) ? "settings.roles.form_header_new" : ((matchValue_1.tag === 1) ? "settings.roles.form_header_new" : "settings.roles.form_header_edit")),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_2 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => map((group_1) => ({
            Id: anchorId(group_1),
            Label: t(PermissionGroup__ToI18nString(group_1)),
        }), groups))),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_5 = toList(delay(() => {
        let matchValue_2;
        return append((matchValue_2 = FormState__getValidation(props.FormState, t, "global"), (matchValue_2 == null) ? singleton(defaultOf()) : singleton(createElement(ErrorAlert, {
            Label: matchValue_2,
        }))), delay(() => {
            let elems_3;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems_3 = toList(delay(() => append(props.Form.IsSystemRole ? singleton(createElement(InformationAlert, {
                Label: "settings.roles.system_role_hint",
            })) : empty(), delay(() => append(singleton(createElement(Input, {
                ComponentState: props.Form.IsSystemRole ? "disabled" : componentState,
                Label: t("settings.roles.name"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "role-name",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: props.Form.Name,
            })), delay(() => {
                const matchValue_3 = FormState__getValidation(props.FormState, t, "permissions");
                return (matchValue_3 == null) ? singleton(defaultOf()) : singleton(createElement(ErrorAlert, {
                    Label: matchValue_3,
                }));
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append(singleton(createElement(PermissionScopeLegend, null)), delay(() => append(map((group_2) => PermissionGroupSection({
                ComponentState: componentState,
                Group: group_2,
                OnChange: (permission, grant) => {
                    props.Dispatch(new Msg(1, [permission, grant]));
                },
                Permissions: props.Form.Permissions,
                Storages: props.Storages,
            }), groups), delay(() => {
                let elems_4;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-8"])], (elems_4 = [createElement(Button, {
                    ComponentState: componentState,
                    Label: t("general.save"),
                    OnClick: () => {
                        props.Dispatch(new Msg(2, []));
                    },
                    TestId: "role-form-save-button",
                    Variant: "primary",
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
            }))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function RoleFormView(props) {
    const t = useTranslation()[0];
    const systemRoleNames = map_1((systemRole) => [systemRole, t(SystemRole__ToI18nString(systemRole))], SystemRoleModule_all);
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => init_1(tupledArg[0], tupledArg[1], tupledArg[2]), update_1, (_arg, _arg_1) => {
    }), [props.Kind, t("settings.roles.copy_suffix"), systemRoleNames], undefined);
    const state_1 = patternInput_1[0];
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.Storages;
    let matchResult, form, storages;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            form = matchValue.fields[0];
            storages = matchValue_1.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(RoleForm, {
                AccountSettings: props.AccountSettings,
                Dispatch: patternInput_1[1],
                Form: form,
                FormState: state_1.FormState,
                Kind: props.Kind,
                Storages: storages,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

